import { button } from '../../../../component/component'

export default function(o){

  if (o.store('role') == "admin" || o.store('role') == "author"){
    var right = '136px'
  } else {
    var right = '102px'
  }

  var ok = function(text){
    div
    .css({
      color: o.colors.red,
    })
    .text(text)
    setTimeout(function(){
      div.html('')
    },3000)
  }

  var div =
    button(
      '',
      null,
      true
    )
    .css({
      position: 'absolute',
      display: 'inline-block',
      right: right,
    })

  o.feedback = {
    ok: ok,
  }

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/feedback/feedback.js